import Card from '@/components/Card';
import { Input } from '@/components/Controls/Input';
import { Datatable } from '@/components/Datatable/Datatable';
import { useEffect, useState } from 'react';
import { debounce } from 'lodash';
import { FieldValues } from 'react-hook-form';
import { TableViewProps } from '@/type/listing.types';
import Loader from '@/components/Loading/Loader';

const limit = 20;

export const VehiculeCheckEmailTableView = <TSchema extends FieldValues>({
  t,
  useGetAllData,
  tableHeaders: TableHeaders,
  tableData: TableData,
  pendingDeactivate,
  onDeactivate,
  id,
}: TableViewProps<TSchema>) => {
  const [debouncedFilter, setDebouncedFilter] = useState(id);
  const [totalPages, setTotalPages] = useState<number>();
  const [currentPage, setCurrentPage] = useState<number>(1);

  /**
   * === Data Fetching section ===
   */
  const { data: allData, isLoading: isLoadingAllData } = useGetAllData(
    debouncedFilter,
    currentPage,
    limit,
  );

  /**
   * === END OF Data Fetching section ===
   */

  /**
   * === Pagination Section ===
   */
  useEffect(() => {
    setTotalPages(allData?.data?.totalPages);
  }, [allData]);
  /**
   * === END OF Pagination Section ===
   */

  /**
   * === Filter section ===
   */
  const debounceFilterUpdate = debounce((value: string) => {
    setDebouncedFilter(value || id);
  }, 300);
  /**
   * === END OF Filter section ===
   */

  return (
    <>
      <Card
        cardClassName="border-0 shadow-none"
        bodyClassName="p-0 flex flex-col gap-5"
      >
        <div className="flex flex-wrap gap-3">
          <Input
            placeholder="Rechercher un email"
            type="text"
            name="search"
            autoComplete="off"
            leftIcon={
              <i className="ki-outline ki-magnifier text-lg text-gray-8990A8" />
            }
            inputWrapperClassName="w-[300px] max-sm:w-full"
            inputClassName="h-10"
            onChange={(e) => debounceFilterUpdate(e.target.value)}
          />
          <div className="text-xs text-slate-500 self-center max-sm:w-full">
            {allData?.data?.data?.length || 0} {t('common:foundResuts')}
          </div>
        </div>
        <div>
          <Datatable
            t={t}
            headers={<TableHeaders t={t} />}
            data={
              isLoadingAllData ? (
                <></>
              ) : !allData?.data?.data?.length ? null : (
                <TableData
                  t={t}
                  data={allData?.data?.data}
                  pendingDeactivate={pendingDeactivate}
                  onDeactivate={onDeactivate}
                />
              )
            }
            showPagination={allData?.data?.data?.length > 0 && totalPages > 1}
            totalPages={totalPages}
            currentPage={currentPage}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </div>
      </Card>
      {isLoadingAllData && <Loader />}
    </>
  );
};
